import React from 'react'
import { useSetRecoilState } from 'recoil'
import { CertNumState, TelNumState } from 'src/recoil/ui'

const useValid = () => {
  const NumRegExp = /[^0-9]/gi
  const setCertNum = useSetRecoilState(CertNumState)
  const setPhoneNum = useSetRecoilState(TelNumState)
  const phoneNumValid = (e: React.ChangeEvent<HTMLInputElement>): void => {
    if (NumRegExp.test(e.target.value)) {
      e.target.value = e.target.value.replaceAll(NumRegExp, '')
    } else {
      setPhoneNum(e.target.value)
    }
  }
  const certNumValid = (e: React.ChangeEvent<HTMLInputElement>): void => {
    if (NumRegExp.test(e.target.value)) {
      e.target.value = e.target.value.replaceAll(NumRegExp, '')
    } else {
      setCertNum(e.target.value)
    }
  }

  return {
    phoneNumValid,
    certNumValid,
  }
}
export default useValid
